import React, {Component} from 'react';
import {Card, CardHeader, Col, FormGroup, Input, Label, Row, TabContent, TabPane} from "reactstrap";
import Alert from 'react-s-alert';
import DefaultModal from "../DefaultModal";
import NumberFormat from 'react-number-format';
import Dropzone from 'react-dropzone'
import {request} from "../../../helper/APIUtils";
import {showAxiosError} from "../../../helper/helper";

class MedulaModal extends Component {

	constructor(props) {
		super(props);
		this.state ={
			btnDisabled :false,
            activeTab: 'uploadPdfTab',
            medulaData:{
			    type:"medula",
			    amount:0,
                allowanceAmount:0,
                contributionAmount:0,
                kdv8Amount:0,
                kdv10Amount:0,
                kdv18Amount:0,
                kdv20Amount:0,
                remunerationAmount:0,
                remunerationKdvAmount:0,
                remunerationKdvAmount20:0,
                payableAmount:0,
                isGocIdaresi: false
            }
		};
		this.onChange    = this.onChange.bind(this);
		this.onDrop      = this.onDrop.bind(this);
		this.onConfirm   = this.onConfirm.bind(this);
	}

    onChange(e){
	    let {name,value}=e;
	    let medulaData = this.state.medulaData;
	    medulaData[name]=value;
	    this.setState({medulaData});
    }

    onDrop(acceptedFiles, rejectedFiles) {
        if (rejectedFiles && rejectedFiles.length) {
            Alert.error("PDF dosyası yüklemelisiniz.", {
                position: 'top-right',
                effect: 'stackslide',
                html: true,
                timeout: 1000
            });
            return;
        }

        if (!acceptedFiles || !acceptedFiles[0])
            return;

        let file = acceptedFiles[0];
        let self = this;

        let formData = new FormData();
        formData.append("file",file);
        let params = {
            url: "/invoiceTmp/uploadMedulaPdf",
            method: "post",
            data: formData
        };

        let medulaData={
            type:"medula",
            amount:0,
            allowanceAmount:0,
            contributionAmount:0,
            kdv0Amount:0,
            kdv8Amount:0,
            kdv10Amount:0,
            kdv18Amount:0,
            kdv20Amount:0,
            kdv0AmountExcluded:0,
            kdv8AmountExcluded:0,
            kdv18AmountExcluded:0,
            examinationFeeS:0,
            examinationFeeH:0,
            remunerationAmount:0,
            remunerationKdvAmount:0,
            remunerationKdvAmount20:0,
            payableAmount:0,
            totalPayableAmount:0,
            sgkMukellefKodu:null,
            sgkMukellefAdi:null,
            sgkFileNo:null,
            groupName:null,
            groupName2:null,
            receiptCount:0,
            issueDate:null,
            itemName:null,
            kdvPercentage:0,
            isGocIdaresi: false,
            eldenIlacKatilimPayi: 0,
            eldenMuayeneKatilimPayi:0,
            eldenReceteKatilimPayi:0,
            maastanIlacKatilimPayi: 0,
            maastanMuayeneKatilimPayi:0,
            maastanReceteKatilimPayi:0,
            startDate:null,
            endDate:null
        };

        self.setState({uploading: true,medulaData});
        request(params)
        .then(function (response) {
            let data = response.data;
            if (data.type === "optik"){
                let medulaData={
                    type:"optik",
                    kdv8Amount: data.kdv8Amount,
                    recipeCount: data.recipeCount,
                    exemptGiven: data.exemptGiven,
                    totalGrossAmount: data.totalGrossAmount,
                    percent10Given: data.percent10Given,
                    totalShareAmount: data.totalShareAmount,
                    percent20Given: data.percent20Given,
                    totalNetAmount: data.totalNetAmount,
                    sgkFileNo: data.sgkFileNo,
                    issueDate: data.issueDate,
                    sgkMukellefAdi: data.sgkMukellefAdi,
                    sgkMukellefKodu: self.props && self.props.currentUser ? self.props.currentUser.sgkMukellefKodu : null,
                    basitUsul: data.basitUsul
                };
                self.setState({medulaData, activeTab: 'enterValueTab'});
            } else if (data.type === "medikalIcmal") {
                let medulaData={
                    type: "medikalIcmal",
                    sgkFileNo: data.sgkFileNo,
                    groupName: data.groupName,
                    groupName2 :data.groupName2,
                    sgkMukellefKodu: data.sgkMukellefKodu,
                    sgkMukellefAdi: data.sgkMukellefAdi,
                    startDate: data.startDate,
                    endDate: data.endDate,
                    contributionAmount: data.contributionAmount,
                    totalPayableAmount: data.totalPayableAmount,
                    kdv8Amount: data.kdv8Amount,
                    kdv8AmountExcluded: data.kdv8AmountExcluded,
                    kdv10Amount: data.kdv10Amount,
                    kdv10AmountExcluded: data.kdv10AmountExcluded,
                    kdv0Amount: data.kdv0Amount,
                    kdv0AmountExcluded: data.kdv0AmountExcluded,
                    kdv18Amount: data.kdv18Amount,
                    kdv18AmountExcluded: data.kdv18AmountExcluded,
                    kdv20Amount: data.kdv20Amount,
                    kdv20AmountExcluded: data.kdv20AmountExcluded,
                    kdvPercentage: data.kdvPercentage,
                    issueDate: data.issueDate,
                };
                self.setState({medulaData, activeTab: 'enterValueTab'});
            } else {
                medulaData = {
                    type: data.type,
                    amount: data.amount,
                    amount2: data.amount2,
                    allowanceAmount: data.allowanceAmount,
                    contributionAmount: data.contributionAmount,
                    contributionAmount2: data.contributionAmount2,
                    kdv8Amount: data.kdv8Amount,
                    kdv10Amount: data.kdv10Amount,
                    kdv18Amount: data.kdv18Amount,
                    kdv20Amount: data.kdv20Amount,
                    examinationFeeS: data.examinationFeeS,
                    examinationFeeH: data.examinationFeeH,
                    remunerationAmount: data.remunerationAmount,
                    remunerationKdvAmount: data.remunerationKdvAmount,
                    remunerationKdvAmount20: data.remunerationKdvAmount20,
                    payableAmount: data.payableAmount,
                    payableAmount2: data.payableAmount2,
                    totalPayableAmount: data.totalPayableAmount,
                    sgkMukellefKodu: data.sgkMukellefKodu,
                    sgkMukellefAdi: data.sgkMukellefAdi,
                    sgkFileNo: data.sgkFileNo,
                    groupName: data.groupName,
                    groupName2: data.groupName2,
                    receiptCount: data.receiptCount,
                    receiptCount2: data.receiptCount2,
                    issueDate: data.issueDate,
                    itemName: data.itemName,
                    kdvPercentage: data.kdvPercentage,
                    isGocIdaresi: data.gocIdaresi,
                    eldenIlacKatilimPayi: data.eldenIlacKatilimPayi,
                    eldenMuayeneKatilimPayi:data.eldenMuayeneKatilimPayi,
                    eldenReceteKatilimPayi:data.eldenReceteKatilimPayi,
                    maastanIlacKatilimPayi: data.maastanIlacKatilimPayi,
                    maastanMuayeneKatilimPayi:data.maastanMuayeneKatilimPayi,
                    maastanReceteKatilimPayi:data.maastanReceteKatilimPayi,
                    psfMiktari:data.psfMiktari
                };

                if(data.type === 'medikal' &&  data.groupName && data.groupName.includes("İşitme")){
                    medulaData["isitmePilAdet"]=null;
                    medulaData["isitmePilBirimFiyat"]=3.85;
                    // medulaData["amount"]=data.payableAmount;
                }
                if (data.type === 'medikal' && data.groupName2 && data.groupName2.includes("Yupas")) {
                    let colonIndex = data.groupName2.indexOf(":");
                    medulaData["groupName2"] = data.groupName2.substring(colonIndex + 1).trim();
                }
                self.setState({medulaData, activeTab: 'enterValueTab'});

            }
        }).catch(function (error) {
            self.setState({uploading: false});
            showAxiosError(error);
        });
    }
    changeCyprusType(){
	    if(this.state.medulaData.type==="cyprusMedula"){
            let medulaData = this.state.medulaData;
            medulaData.type = "medula";
            this.setState({medulaData});
        }
        this.setState({btnDisabled:false}, () => { this.state.medulaData.type === "optik" ?
            this.props.applyMedulaOptik(this.state.medulaData) : (this.state.medulaData.type === "medikalIcmal" ? this.props.applyMedikalIcmal(this.state.medulaData) :
                (this.state.medulaData.type === "medikal"? this.props.applyMedikal(this.state.medulaData) : this.props.applyMedula(this.state.medulaData)));
        })
    }

    onConfirm(){
        this.setState({btnDisabled:false});
	    if(this.state.medulaData.type === "optik"){
            this.props.applyMedulaOptik(this.state.medulaData);
        }else if(this.state.medulaData.type === "medikalIcmal"){
            this.props.applyMedikalIcmal(this.state.medulaData);
        }else if(this.state.medulaData.type === "medikal"){
	        if((this.state.medulaData.type === 'medikal' &&  this.state.medulaData.groupName && this.state.medulaData.groupName.includes("İşitme"))){
	            if(this.state.medulaData.isitmePilAdet == null){
                    Alert.error("İşitme Cihazı Pil Adedi boş bırakılamaz.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        html: true,
                        timeout: 1000
                    });
	            }else{
                    this.props.applyMedikal(this.state.medulaData);
                }
            }else{
                this.props.applyMedikal(this.state.medulaData);
            }
        }else{
            this.props.applyMedula(this.state.medulaData);
        }
    }

	render() {

	    let medulaData= this.state.medulaData;

		return (
			<DefaultModal disabled={this.state.btnDisabled}
                          size="lg"
						  isOpen={this.props.medulaModal}
						  title="Medula Döküm Aktarımı"
						  confirmBtnText="Uygula"
						  cancelBtnText="Kapat"
						  onConfirm={this.onConfirm}
						  onCancel={(e)=>this.setState({btnDisabled:false}, () => {
							  this.props.toggleModal(false);
						  })}>
                <Card className="">
                    <CardHeader>
                        <div className="nav-tabs-navigation">
                            <div className="nav-tabs-wrapper">
                                <ul className="nav tabBackground nav-tabs" data-tabs="tabs">
                                    <li className="nav-item">
                                        <a className={"nav-link " + (this.state.activeTab === 'uploadPdfTab' ? 'active' : '')}
                                           onClick={() => {this.setState({activeTab: 'uploadPdfTab'})}}
                                           data-toggle="tab">PDF'ten Aktarım</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className={"nav-link " + (this.state.activeTab === 'enterValueTab' ? 'active' : '')}
                                           onClick={() => {this.setState({activeTab: 'enterValueTab'})}}
                                           data-toggle="tab">Manuel Giriş</a>
                                    </li>
                                </ul>
                                <hr></hr>
                            </div>
                        </div>
                    </CardHeader>
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="uploadPdfTab">
                            <Col sm="12" style={{paddingLeft:0}}>
                                <Col sm={12}>
                                     <Dropzone
                                        accept=".pdf"
                                        className="FormRenk col-sm-12"
                                        activeClassName="dropzoneActiveClass"
                                        style={{marginTop: '15px'}}
                                        multiple={false}
                                        maxSize={5000000}
                                        onDrop={this.onDrop}>
                                        <div className="dropzoneInnerArea">
                                            Medula Döküm PDF'ini buraya sürükleyiniz.
                                        </div>
                                     </Dropzone>
                                </Col>
                            </Col>
                        </TabPane>
                        <TabPane tabId="enterValueTab">
                            <Row style={{paddingLeft:0}}>
                                {(this.state.medulaData.type==="medikal" || this.state.medulaData.type === "medikalIcmal") &&
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label sm={4}>{this.state.medulaData.type === "medikalIcmal" ? "Evrak Türü: *" : "Ürün Adı: *"}</Label>
                                            <Col sm={12}>
                                                <Input value={medulaData.groupName} onChange={(e) => this.onChange({
                                                    value: e.target.value,
                                                    name: "groupName"
                                                })}/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                }
                                {(this.state.medulaData.type !== "optik" && this.state.medulaData.type !== "medikalIcmal") &&
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label sm={4}>Reçete Adet: *</Label>
                                            <Col sm={12}>
                                                <Input value={medulaData.receiptCount} onChange={(e) => this.onChange({
                                                    value: e.target.value,
                                                    name: "receiptCount"
                                                })}/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                }
                                {(this.state.medulaData.type !== "optik" && this.state.medulaData.type !== "medikalIcmal" && this.state.medulaData.receiptCount2 !== null) &&
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label sm={4}>Reçete Adet (İkinci Satır): *</Label>
                                            <Col sm={12}>
                                                <Input value={medulaData.receiptCount2} onChange={(e) => this.onChange({
                                                    value: e.target.value,
                                                    name: "receiptCount2"
                                                })}/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                }
                                {(this.state.medulaData.type==="medula") || (this.state.medulaData.type==="medikal") &&
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label sm={4}>Reçete Grubu: *</Label>
                                            <Col sm={12}>
                                                <Input value={medulaData.groupName} onChange={(e) => this.onChange({
                                                    value: e.target.value,
                                                    name: "groupName"
                                                })}/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                }
                                {(this.state.medulaData.type ==="medikal" && this.state.medulaData.contributionAmount2 !== null) &&
                                    <Col sm={6}>
                                         <FormGroup>
                                             <Label sm={4} > Reçete Grubu (İkinci Satır): *</Label>
                                             <Col sm={12}>
                                                 <Input value={medulaData.groupName2} onChange={(e) => this.onChange({
                                                     value: e.target.value,
                                                     name: "groupName2"
                                                 })}/>

                                             </Col>
                                         </FormGroup>
                                     </Col>
                                }
                                {this.state.medulaData.type !== "optik" &&
                                    <React.Fragment>
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>{this.state.medulaData.type === "medikalIcmal" ? "Merkez Kodu: *" : "Eczane Sicili: *"}</Label>
                                                <Col sm={12}>
                                                    <Input value={medulaData.sgkMukellefKodu} onChange={(e) => this.onChange({
                                                        value: e.target.value,
                                                        name: "sgkMukellefKodu"
                                                    })}/>
                                                </Col>
                                            </FormGroup>
                                        </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>{this.state.medulaData.type === "medikalIcmal" ? "Merkez Adı: *" : "Eczane Adı: *"}</Label>
                                                <Col sm={12}>
                                                    <Input value={medulaData.sgkMukellefAdi} onChange={(e) => this.onChange({
                                                        value: e.target.value,
                                                        name: "sgkMukellefAdi"
                                                    })}/>
                                                </Col>
                                            </FormGroup>
                                        </Col>

                                        {(this.state.medulaData.type === 'medikal' &&  this.state.medulaData.groupName && this.state.medulaData.groupName.includes("İşitme")) &&
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>İşitme Cihazı Pil Adedi: *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="isitmePilAdet"
                                                                  value={medulaData.isitmePilAdet}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value === "" ? false : true);
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "isitmePilAdet"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                        }

                                        {(this.state.medulaData.type === 'medikal' &&  this.state.medulaData.groupName && this.state.medulaData.groupName.includes("İşitme")) &&
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>İşitme Cihazı 1 Adet Pil Tutarı : *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="isitmePilBirimFiyat"
                                                                  value={medulaData.isitmePilBirimFiyat}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value === "" ? false : true);
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "isitmePilBirimFiyat"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                        }

                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>{this.state.medulaData.type === "medikalIcmal" ? "Evrak Referans No: *" : "Doküman Numarası: *"}</Label>
                                                <Col sm={12}>
                                                    <Input value={medulaData.sgkFileNo} onChange={(e) => this.onChange({
                                                        value: e.target.value,
                                                        name: "sgkFileNo"
                                                    })}/>
                                                </Col>
                                            </FormGroup>
                                        </Col>

                                        {this.state.medulaData.type !== "medikalIcmal" &&
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>Tutar: *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="amount"
                                                                  value={medulaData.amount}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value === "" ? false : true);
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "amount"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>}

                                        {(this.state.medulaData.type !== "medikalIcmal" && this.state.medulaData.amount2 !== null) &&
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>Tutar (İkinci Satır): *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="amount2"
                                                                  value={medulaData.amount2}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value === "" ? false : true);
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "amount2"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>}
                                    </React.Fragment>
                                }
                                {(this.state.medulaData.type==="medula" || this.state.medulaData.type==="cyprusMedula")&&
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label sm={4}>İskonto Tutar: *</Label>
                                            <Col sm={12}>
                                                <NumberFormat id="allowanceAmount"
                                                              value={medulaData.allowanceAmount}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={9}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              isAllowed={values => {
                                                                  return (values.value === "" ? false : true);
                                                              }}
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  value: e.value,
                                                                  name: "allowanceAmount"
                                                              })}
                                                              className="form-control"/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                }
                                {this.state.medulaData.type !== "optik" &&
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label sm={4}>{this.state.medulaData.type==="medikal" ? "Katılım Payı: *" :
                                                (this.state.medulaData.type === "medikalIcmal" ? "Toplam Katılım Payı: *" : "%10-%20 Kat.Payı: *")}</Label>
                                            <Col sm={12}>
                                                <NumberFormat id="contributionAmount"
                                                              value={medulaData.contributionAmount}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={9}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              isAllowed={values => {
                                                                  return (values.value === "" ? false : true);
                                                              }}
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  value: e.value,
                                                                  name: "contributionAmount"
                                                              })}
                                                              className="form-control"/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                }
                                {(this.state.medulaData.type !== "optik" && this.state.medulaData.contributionAmount2 !== null) &&
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label sm={4}>Katılım Payı (İkinci Satır): *</Label>
                                            <Col sm={12}>
                                                <NumberFormat id="contributionAmount2"
                                                              value={medulaData.contributionAmount2}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={9}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              isAllowed={values => {
                                                                  return (values.value === "" ? false : true);
                                                              }}
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  value: e.value,
                                                                  name: "contributionAmount2"
                                                              })}
                                                              className="form-control"/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                }
                                {(this.state.medulaData.type==="medula" || this.state.medulaData.type==="cyprusMedula") &&
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label sm={4}>%8 KDV: *</Label>
                                            <Col sm={12}>
                                                <NumberFormat id="kdv8Amount"
                                                              value={medulaData.kdv8Amount}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={9}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              isAllowed={values => {
                                                                  return (values.value === "" ? false : true);
                                                              }}
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  value: e.value,
                                                                  name: "kdv8Amount"
                                                              })}
                                                              className="form-control"/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                }
                                {(this.state.medulaData.type==="medula" || this.state.medulaData.type==="cyprusMedula") &&
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label sm={4}>%10 KDV: *</Label>
                                            <Col sm={12}>
                                                <NumberFormat id="kdv10Amount"
                                                              value={medulaData.kdv10Amount}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={9}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              isAllowed={values => {
                                                                  return (values.value === "" ? false : true);
                                                              }}
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  value: e.value,
                                                                  name: "kdv10Amount"
                                                              })}
                                                              className="form-control"/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                }
                                {this.state.medulaData.type === "medikal" &&
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label sm={4}>KDV Oranı(%): *</Label>
                                            <Col sm={12}>
                                                <NumberFormat id="kdvPercentage"
                                                              value={medulaData.kdvPercentage}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={2}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              isAllowed={values => {
                                                                  return (values.value === "" ? false : true);
                                                              }}
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  value: e.value,
                                                                  name: "kdvPercentage"
                                                              })}
                                                              className="form-control"/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                }
                                {(this.state.medulaData.type==="medula" || this.state.medulaData.type==="cyprusMedula") &&
                                    <React.Fragment>
                                        {this.state.medulaData.type!=="cyprusMedula" &&
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>%18 KDV: *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="kdv18Amount"
                                                                  value={medulaData.kdv18Amount}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value === "" ? false : true);
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "kdv18Amount"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                        }

                                        {this.state.medulaData.type!=="cyprusMedula" &&
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label sm={4}>%20 KDV: *</Label>
                                                    <Col sm={12}>
                                                        <NumberFormat id="kdv20Amount"
                                                                      value={medulaData.kdv20Amount}
                                                                      allowNegative={false}
                                                                      isNumericString={true}
                                                                      allowEmptyFormatting={false}
                                                                      decimalScale={9}
                                                                      thousandSeparator={'.'}
                                                                      decimalSeparator={','}
                                                                      displayType="input"
                                                                      isAllowed={values => {
                                                                          return (values.value === "" ? false : true);
                                                                      }}
                                                                      renderText={value => {
                                                                          value.replace(/\./g, ',')
                                                                      }}
                                                                      onValueChange={(e) => this.onChange({
                                                                          value: e.value,
                                                                          name: "kdv20Amount"
                                                                      })}
                                                                      className="form-control"/>
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                        }

                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>Eczane Hizmet Bedeli: *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="remunerationAmount"
                                                                  value={medulaData.remunerationAmount}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value === "" ? false : true);
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "remunerationAmount"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>Eczane Hizmet Bed. Kdv Tutarı(%18): *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="remunerationKdvAmount"
                                                                  value={medulaData.remunerationKdvAmount}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value === "" ? false : true);
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "remunerationKdvAmount"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>Eczane Hizmet Bed. Kdv Tutarı(%20): *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="remunerationKdvAmount20"
                                                                  value={medulaData.remunerationKdvAmount20}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value === "" ? false : true);
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "remunerationKdvAmount20"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>

                                        {this.state.medulaData.type!=="cyprusMedula"&&
                                        <React.Fragment>
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>İlaç Katılım Payı(Elden): *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="eldenIlacKatilimPayi"
                                                                  value={medulaData.eldenIlacKatilimPayi}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value !== "");
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "eldenIlacKatilimPayi"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                            <Label sm={4}>İlaç Katılım Payı(Maaştan): *</Label>
                                            <Col sm={12}>
                                            <NumberFormat id="maastanIlacKatilimPayi"
                                            value={medulaData.maastanIlacKatilimPayi}
                                            allowNegative={false}
                                            isNumericString={true}
                                            allowEmptyFormatting={false}
                                            decimalScale={9}
                                            thousandSeparator={'.'}
                                            decimalSeparator={','}
                                            displayType="input"
                                            isAllowed={values => {
                                            return (values.value !== "");
                                        }}
                                            renderText={value => {
                                            value.replace(/\./g, ',')
                                        }}
                                            onValueChange={(e) => this.onChange({
                                            value: e.value,
                                            name: "maastanIlacKatilimPayi"
                                        })}
                                            className="form-control"/>
                                            </Col>
                                            </FormGroup>
                                            </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                            <Label sm={4}>Muayene Katılım Payı(Elden): *</Label>
                                            <Col sm={12}>
                                            <NumberFormat id="eldenMuayeneKatilimPayi"
                                            value={medulaData.eldenMuayeneKatilimPayi}
                                            allowNegative={false}
                                            isNumericString={true}
                                            allowEmptyFormatting={false}
                                            decimalScale={9}
                                            thousandSeparator={'.'}
                                            decimalSeparator={','}
                                            displayType="input"
                                            isAllowed={values => {
                                            return (values.value !== "");
                                        }}
                                            renderText={value => {
                                            value.replace(/\./g, ',')
                                        }}
                                            onValueChange={(e) => this.onChange({
                                            value: e.value,
                                            name: "eldenMuayeneKatilimPayi"
                                        })}
                                            className="form-control"/>
                                            </Col>
                                            </FormGroup>
                                            </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                            <Label sm={4}>Muayene Katılım Payı(Maaştan): *</Label>
                                            <Col sm={12}>
                                            <NumberFormat id="maastanMuayeneKatilimPayi"
                                            value={medulaData.maastanMuayeneKatilimPayi}
                                            allowNegative={false}
                                            isNumericString={true}
                                            allowEmptyFormatting={false}
                                            decimalScale={9}
                                            thousandSeparator={'.'}
                                            decimalSeparator={','}
                                            displayType="input"
                                            isAllowed={values => {
                                            return (values.value !== "");
                                        }}
                                            renderText={value => {
                                            value.replace(/\./g, ',')
                                        }}
                                            onValueChange={(e) => this.onChange({
                                            value: e.value,
                                            name: "maastanMuayeneKatilimPayi"
                                        })}
                                            className="form-control"/>
                                            </Col>
                                            </FormGroup>
                                            </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                            <Label sm={4}>Reçete Kat.Payı Elden(Elden): *</Label>
                                            <Col sm={12}>
                                            <NumberFormat id="eldenReceteKatilimPayi"
                                            value={medulaData.eldenReceteKatilimPayi}
                                            allowNegative={false}
                                            isNumericString={true}
                                            allowEmptyFormatting={false}
                                            decimalScale={9}
                                            thousandSeparator={'.'}
                                            decimalSeparator={','}
                                            displayType="input"
                                            isAllowed={values => {
                                            return (values.value !== "");
                                        }}
                                            renderText={value => {
                                            value.replace(/\./g, ',')
                                        }}
                                            onValueChange={(e) => this.onChange({
                                            value: e.value,
                                            name: "eldenReceteKatilimPayi"
                                        })}
                                            className="form-control"/>
                                            </Col>
                                            </FormGroup>
                                            </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                            <Label sm={4}>Reçete Kat.Payı Elden(Maaştan): *</Label>
                                            <Col sm={12}>
                                            <NumberFormat id="maastanReceteKatilimPayi"
                                            value={medulaData.maastanReceteKatilimPayi}
                                            allowNegative={false}
                                            isNumericString={true}
                                            allowEmptyFormatting={false}
                                            decimalScale={9}
                                            thousandSeparator={'.'}
                                            decimalSeparator={','}
                                            displayType="input"
                                            isAllowed={values => {
                                            return (values.value !== "");
                                        }}
                                            renderText={value => {
                                            value.replace(/\./g, ',')
                                        }}
                                            onValueChange={(e) => this.onChange({
                                            value: e.value,
                                            name: "maastanReceteKatilimPayi"
                                        })}
                                            className="form-control"/>
                                            </Col>
                                            </FormGroup>
                                            </Col>
                                        </React.Fragment>
                                        }
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>PSF Miktarı: *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="psfMiktari"
                                                                  value={medulaData.psfMiktari}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value !== "");
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "psfMiktari"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                    </React.Fragment>
                                }
                                {(this.state.medulaData.type !== "optik" && this.state.medulaData.type !== "medikalIcmal") &&
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label sm={4}>Ödenecek Tutar: *</Label>
                                            <Col sm={12}>
                                                <NumberFormat id="payableAmount"
                                                              value={medulaData.payableAmount}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={9}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              isAllowed={values => {
                                                                  return (values.value === "" ? false : true);
                                                              }}
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  value: e.value,
                                                                  name: "payableAmount"
                                                              })}
                                                              className="form-control"/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                }
                                {(this.state.medulaData.type !== "optik" && this.state.medulaData.type !== "medikalIcmal" && this.state.medulaData.payableAmount2 !== null) &&
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label sm={4}>Ödenecek Tutar (İkinci Satır): *</Label>
                                            <Col sm={12}>
                                                <NumberFormat id="payableAmount2"
                                                              value={medulaData.payableAmount2}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={9}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              isAllowed={values => {
                                                                  return (values.value === "" ? false : true);
                                                              }}
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  value: e.value,
                                                                  name: "payableAmount2"
                                                              })}
                                                              className="form-control"/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                }
                                {(this.state.medulaData.type==="medula" || this.state.medulaData.type === "medikalIcmal" || this.state.medulaData.type==="cyprusMedula") &&
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label sm={4}>Toplam Ödenecek Tutar: *</Label>
                                            <Col sm={12}>
                                                <NumberFormat id="totalPayableAmount"
                                                              value={medulaData.totalPayableAmount}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={9}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              isAllowed={values => {
                                                                  return (values.value === "" ? false : true);
                                                              }}
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  value: e.value,
                                                                  name: "totalPayableAmount"
                                                              })}
                                                              className="form-control"/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                }
                                {this.state.medulaData.type === "optik" &&
                                    <React.Fragment>
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>Reçete Sayısı: *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="recipeCount"
                                                                  value={medulaData.recipeCount}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value !== "");
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "recipeCount"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>Evrak Referans No: *</Label>
                                                <Col sm={12}>
                                                    <Input value={medulaData.sgkFileNo} onChange={(e) => this.onChange({
                                                        value: e.target.value,
                                                        name: "sgkFileNo"
                                                    })}/>
                                                </Col>
                                            </FormGroup>
                                        </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>Muaf Verilen: *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="exemptGiven"
                                                                  value={medulaData.exemptGiven}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value !== "");
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "exemptGiven"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>%10 Katılımlı Verilen: *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="percent10Given"
                                                                  value={medulaData.percent10Given}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value !== "");
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "percent10Given"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>%20 Katılımlı Verilen: *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="percent20Given"
                                                                  value={medulaData.percent20Given}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value !== "");
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "percent20Given"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>Toplam Brüt Reçete Tutar: *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="totalGrossAmount"
                                                                  value={medulaData.totalGrossAmount}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value !== "");
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "totalGrossAmount"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>Toplam Katılım Payı: *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="totalShareAmount"
                                                                  value={medulaData.totalShareAmount}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value !== "");
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "totalShareAmount"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label sm={4}>Toplam Net Reçete Tutarı: *</Label>
                                                <Col sm={12}>
                                                    <NumberFormat id="totalNetAmount"
                                                                  value={medulaData.totalNetAmount}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  isAllowed={values => {
                                                                      return (values.value !== "");
                                                                  }}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "totalNetAmount"
                                                                  })}
                                                                  className="form-control"/>
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                    </React.Fragment>
                                }
                                {this.state.medulaData.type==="medikalIcmal" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>KDV Dahil %0 Tutar: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="kdv0Amount"
                                                          value={medulaData.kdv0Amount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "kdv0Amount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                }
                                {this.state.medulaData.type==="medikalIcmal" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>KDV Hariç %0 Tutar: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="kdv0AmountExcluded"
                                                          value={medulaData.kdv0AmountExcluded}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "kdv0AmountExcluded"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                }{this.state.medulaData.type==="medikalIcmal" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>KDV Dahil %0 Tutar: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="kdv0Amount"
                                                          value={medulaData.kdv0Amount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "kdv0Amount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                }
                                {this.state.medulaData.type==="medikalIcmal" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>KDV Hariç %0 Tutar: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="kdv0AmountExcluded"
                                                          value={medulaData.kdv0AmountExcluded}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "kdv0AmountExcluded"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                }
                                {this.state.medulaData.type==="medikalIcmal" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>KDV Dahil %8 Tutar: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="kdv8Amount"
                                                          value={medulaData.kdv8Amount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "kdv8Amount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                }
                                {this.state.medulaData.type==="medikalIcmal" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>KDV Hariç %8 Tutar: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="kdv8AmountExcluded"
                                                          value={medulaData.kdv8AmountExcluded}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "kdv8AmountExcluded"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                }
                                {this.state.medulaData.type==="medikalIcmal" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>KDV Dahil %10 Tutar: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="kdv10Amount"
                                                          value={medulaData.kdv10Amount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "kdv10Amount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                }
                                {this.state.medulaData.type==="medikalIcmal" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>KDV Hariç %10 Tutar: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="kdv10AmountExcluded"
                                                          value={medulaData.kdv10AmountExcluded}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "kdv10AmountExcluded"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                }
                                {this.state.medulaData.type==="medikalIcmal" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>KDV Dahil %18 Tutar: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="kdv18Amount"
                                                          value={medulaData.kdv18Amount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "kdv18Amount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                }
                                {this.state.medulaData.type==="medikalIcmal" &&
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label sm={4}>KDV Hariç %18 Tutar: *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="kdv18AmountExcluded"
                                                          value={medulaData.kdv18AmountExcluded}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              return (values.value !== "");
                                                          }}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "kdv18AmountExcluded"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                }
                                {this.state.medulaData.type==="medikalIcmal" &&
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label sm={4}>KDV Dahil %20 Tutar: *</Label>
                                            <Col sm={12}>
                                                <NumberFormat id="kdv10Amount"
                                                              value={medulaData.kdv20Amount}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={9}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              isAllowed={values => {
                                                                  return (values.value !== "");
                                                              }}
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  value: e.value,
                                                                  name: "kdv20Amount"
                                                              })}
                                                              className="form-control"/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                }
                                {this.state.medulaData.type==="medikalIcmal" &&
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label sm={4}>KDV Hariç %20 Tutar: *</Label>
                                            <Col sm={12}>
                                                <NumberFormat id="kdv20AmountExcluded"
                                                              value={medulaData.kdv20AmountExcluded}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={9}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              isAllowed={values => {
                                                                  return (values.value !== "");
                                                              }}
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  value: e.value,
                                                                  name: "kdv20AmountExcluded"
                                                              })}
                                                              className="form-control"/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                }
                            </Row>
                        </TabPane>
                    </TabContent>
                </Card>
			</DefaultModal>
		)
	}
}

export default MedulaModal;